/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
CiudadanoIncidenciaService.$inject = ['$resource'];
export default function CiudadanoIncidenciaService($resource) {
    var urlBase = Sigo.var.path + '/api/v1/incidencias/:incidenciaId/ciudadanos';

    return $resource(urlBase + '/:ciudadanoId', {
            incidenciaId: '@incidenciaId',
            ciudadanoId: '@inspeccionId'
        }, {
            'update': {method: 'PUT'},
            //'create': {method: 'GET', url: urlBase + '/create'},
            'edit': {method: 'GET', url: urlBase + '/:ciudadanoId/edit'}
        }
    );
}